<template>
	<b-input-group>
		<b-input v-bind="$attrs" :value="value" @input="$emit('input', $event)" @keydown.esc="clear"></b-input>
		<b-input-group-append v-if="value">
			<b-button variant="outline-secondary" @click="clear" tabindex="-1"><b-icon icon="x"></b-icon></b-button>
		</b-input-group-append>
	</b-input-group>
</template>

<script>
export default {
	name: 'SearchInput',
	inheritAttrs: false,
	props: {
		value: { type: String, default: '' },
	},
	methods: {
		clear() {
			this.$emit('input', '');
		},
	},
};
</script>
